// Utilidades compartidas de las vistas del cajero.
import { theme } from '../../theme';

export const c = theme.colors;

export function money(v) {
  const n = Number(v) || 0;
  return '$ ' + n.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

// Color e etiqueta por estado (facturas/pos y cotizaciones).
export const STATUS_META = {
  pagada: { label: 'Pagada', color: '#4ade80' },
  deben: { label: 'Deben', color: '#fbbf24' },
  cancelada: { label: 'Cancelada', color: '#f87171' },
  pendiente: { label: 'Pendiente', color: '#fbbf24' },
  aprobada: { label: 'Aprobada', color: '#4ade80' },
  rechazada: { label: 'Rechazada', color: '#f87171' },
  emitida: { label: 'Emitida', color: '#38bdf8' },
};

// Cálculo de una línea (espejo del servidor, solo para previsualizar).
export function computeLine(it) {
  const qty = parseFloat(it.quantity) || 0;
  const price = parseFloat(it.unit_price) || 0;
  const subtotal = qty * price;
  const iva = subtotal * (parseFloat(it.iva_percent) || 0) / 100;
  const impo = subtotal * (parseFloat(it.impoconsumo_percent) || 0) / 100;
  const rete = subtotal * (parseFloat(it.retefuente_percent) || 0) / 100;
  const tax = iva + impo - rete;
  return { subtotal, iva, impo, rete, tax, total: subtotal + tax };
}

export function computeTotals(items) {
  const t = { subtotal: 0, iva: 0, impo: 0, rete: 0, total: 0 };
  for (const it of items) {
    const l = computeLine(it);
    t.subtotal += l.subtotal; t.iva += l.iva; t.impo += l.impo; t.rete += l.rete; t.total += l.total;
  }
  return t;
}

export const inputStyle = {
  width: '100%', padding: '9px 11px', borderRadius: '7px',
  border: `1px solid ${c.border}`, background: c.background, color: c.text,
  fontSize: '0.9rem', boxSizing: 'border-box',
};
export const labelStyle = { display: 'block', fontSize: '0.75rem', color: c.textMuted, marginBottom: '4px' };
